/* eslint-disable import/no-cycle */
import { Stack, HStack, Divider, Box } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import { useGetItemProperty } from '../hooks/useGetItemProperty';
import InputPreview from '../formInputs/InputPreview';
import { FormBuilderComponentProps, FormFieldT } from '../types';
import ComponentButtonPreview from './ComponentButtonPreview';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from '../schemas/formComponentInputTypeSchema';
import { useStoreState } from '../../../../models/hooks';

const NumberField = React.memo(
  ({ fieldId, isAdvanced, labelRightRenderer }: Omit<FormBuilderComponentProps, 'path'>) => {
    const { t } = useTranslation('hrFormTemplate');
    const inputType = useGetItemProperty<FormFieldT['inputType']>(fieldId, 'inputType');
    const currentLanguage = useStoreState((state) => state.formBuilder.currentLanguage);

    const showShowMe = [
      FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber,
      FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber,
      FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber,
      FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber,
    ].some((x) => x === inputType);
    return (
      <Stack>
        <HStack justify="space-between">
          <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
          <HStack flexShrink={0}>
            <Divider orientation="vertical" />
            {labelRightRenderer}
          </HStack>
        </HStack>
        <FormTextInput
          fieldId={fieldId}
          placeholder={t('formBuilder.editorPlaceholder.number')}
          isAdvanced={isAdvanced || false}
        />
        <InputPreview fieldId={fieldId} value="1234567890" />
        {showShowMe && (
          <Box>
            <ComponentButtonPreview label={t('formBuilder.showMe', { lng: currentLanguage })} disabled />
          </Box>
        )}
      </Stack>
    );
  },
  (prev, next) =>
    /* eslint-disable-next-line  */
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);

NumberField.displayName = 'NumberField';
export default NumberField;
